import Helmet from 'react-helmet';
import { ArrowNoCircleIcon } from '@karma/components/icons';
import { useTranslation } from 'react-i18next';
import { Typography, Button } from '@karma/components';
import { getColor } from '@karma/components/colors';
import { Link } from 'react-router-dom';
import WebsiteLayout from 'components/templates/WebsiteLayout/WebsiteLayout';
import { PATHS } from 'consts/paths';
import { getCookieValue } from 'functions/cookies';
import { COOKIES } from 'consts/cookies';
import { ButtonWrap, Layout, ColSimple } from './ErrorPage.style';

const ErrorPage = () => {
  const { t } = useTranslation();

  const illustration404 = (
    <svg width="200" height="77" viewBox="0 0 200 78" xmlns="http://www.w3.org/2000/svg">
      <g fill={getColor('primary1')}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65.3133 43.2V58.9H54.7133V75.5H36.3133V58.9H0.113281V44.1434L0.858045 43.543C15.7758 31.5168 26.4555 17.9026 32.9754 2.71121L33.4952 1.5H54.7133V43.2H65.3133ZM38.3133 56.9V73.5H52.7133V56.9H63.3133V45.2H52.7133V3.5H34.8133C28.1466 19.0333 17.2466 32.9 2.11328 45.1V56.9H38.3133ZM21.2575 43.2C20.5549 43.8748 19.8402 44.5414 19.1133 45.2H38.3133V21.2C37.6698 22.3497 37.0031 23.4839 36.3133 24.6027C32.1423 31.3669 27.1237 37.566 21.2575 43.2ZM24.1146 43.2H36.3133V28.3131C32.7817 33.6356 28.7146 38.5982 24.1146 43.2ZM83.0899 72.3974L83.0787 72.3904C78.1863 69.2967 74.3823 64.8218 71.6415 59.059L71.6353 59.0458L71.6292 59.0326C68.9513 53.1835 67.6477 46.3541 67.6477 38.6C67.6477 30.7831 68.95 23.9487 71.633 18.1591L71.6375 18.1494C74.3758 12.3218 78.1787 7.80894 83.076 4.71132C88.0244 1.55683 93.6696 0 99.9477 0C106.224 0 111.867 1.55577 116.814 4.7081C121.779 7.80455 125.586 12.3193 128.26 18.154C131.012 23.9458 132.348 30.7825 132.348 38.6C132.348 46.3578 131.009 53.1916 128.261 59.0441C125.583 64.8214 121.771 69.3029 116.805 72.3974C111.858 75.4804 106.218 77 99.9477 77C93.677 77 88.037 75.4804 83.0899 72.3974ZM126.448 58.2C129.048 52.6667 130.348 46.1333 130.348 38.6C130.348 31 129.048 24.4667 126.448 19C123.914 13.4667 120.348 9.26667 115.748 6.4C111.148 3.46667 105.881 2 99.9477 2C94.0143 2 88.7477 3.46667 84.1477 6.4C79.6143 9.26667 76.0477 13.4667 73.4477 19C70.9143 24.4667 69.6477 31 69.6477 38.6C69.6477 46.1333 70.9143 52.6667 73.4477 58.2C76.0477 63.6667 79.6143 67.8333 84.1477 70.7C88.7477 73.5667 94.0143 75 99.9477 75C105.881 75 111.148 73.5667 115.748 70.7C120.348 67.8333 123.914 63.6667 126.448 58.2ZM109.562 21.7763L109.556 21.767C107.159 17.9674 104.007 16.2 99.9477 16.2C95.8881 16.2 92.7359 17.9674 90.3393 21.767C87.8825 25.6619 86.5477 31.2066 86.5477 38.6C86.5477 45.9132 87.8776 51.4215 90.3297 55.3178C92.7929 59.0631 95.9539 60.8 99.9477 60.8C104.022 60.8 107.173 59.0523 109.564 55.3212L109.568 55.3146C112.083 51.4213 113.448 45.9157 113.448 38.6C113.448 31.2135 112.082 25.6763 109.568 21.7854L109.562 21.7763ZM199.884 43.2V58.9H189.284V75.5H170.884V58.9H134.684V44.1434L135.428 43.543C150.346 31.5168 161.026 17.9026 167.546 2.71121L168.066 1.5H189.284V43.2H199.884ZM187.284 45.2V3.5H169.384C162.717 19.0333 151.817 32.9 136.684 45.1V56.9H172.884V73.5H187.284V56.9H197.884V45.2H187.284ZM153.684 45.2H172.884V21.2C172.24 22.3497 171.573 23.4839 170.884 24.6027C166.713 31.3669 161.694 37.566 155.828 43.2C155.125 43.8748 154.41 44.5414 153.684 45.2ZM158.685 43.2H170.884V28.3131C167.352 33.6356 163.285 38.5982 158.685 43.2ZM111.248 56.4C108.514 60.6667 104.748 62.8 99.9477 62.8C95.2143 62.8 91.4477 60.6667 88.6477 56.4C85.9143 52.0667 84.5477 46.1333 84.5477 38.6C84.5477 31 85.9143 25.0333 88.6477 20.7C91.381 16.3667 95.1477 14.2 99.9477 14.2C104.748 14.2 108.514 16.3667 111.248 20.7C114.048 25.0333 115.448 31 115.448 38.6C115.448 46.1333 114.048 52.0667 111.248 56.4Z"
          fill="#1B1C1D"
        />
      </g>
    </svg>
  );

  return (
    <>
      <Helmet>
        <title>{t('app:headerError')}</title>
        <meta key="robots_noindex" name="robots" content="noindex, nocache" />
      </Helmet>

      <WebsiteLayout>
        <Layout>
          <div>{illustration404}</div>
          <ColSimple>
            <Typography variant="h3" color="primary1">
              {t('app:pageNotFound')}
            </Typography>
            <Typography variant="paragraphLarge" color="primary1">
              {t('app:pageDoesNotExist')}
            </Typography>
          </ColSimple>

          <ButtonWrap>
            <Button
              size="medium"
              as={Link}
              to={getCookieValue(COOKIES.logged) ? PATHS.HOME : PATHS.WEBSITE_LANDING_PATH}
              back
            >
              {t('app:backHome')}
            </Button>

            <Button
              Icon={ArrowNoCircleIcon}
              size="medium"
              as={Link}
              iconPosition="right"
              type="outline"
              to={getCookieValue(COOKIES.logged) ? PATHS.STORES : PATHS.KARMA_CASH}
            >
              {t('app:startShopping')}
            </Button>
          </ButtonWrap>
        </Layout>
      </WebsiteLayout>
    </>
  );
};

export default ErrorPage;
